import React, { useState } from 'react';
import { User } from "../typings";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { MdOutlineMoreVert } from "react-icons/md";
import ConfirmationDialog from "../tags/ConfirmationDialog";
import { useNavigate } from "react-router-dom";

interface Props {
    user: User;
    onRemove: (id: number) => void;
}

function UserRow(props: Props) {
    const [dialogOpen, setDialogOpen] = useState(false);

    const navigate = useNavigate();

    return (
        <div className="box" style={{
            flexDirection: 'row' as 'row',
            padding: '12px 16px',
            width: '100%',
            alignItems: 'center'
        }}>
            <div className="drill-row-item" style={{flex: 2, cursor: 'pointer'}} onClick={() => navigate(`/user/${props.user.id}`)}>{props.user.email}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.user.accountType}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.user.license}</div>
            <div className="drill-row-item" style={{flex: 2}}>{props.user.role}</div>
            <Menu>
                <MenuButton className="menu-button"><MdOutlineMoreVert size="24px"/></MenuButton>
                <MenuItems
                    className="menu-box"
                    anchor="bottom"
                >
                    <MenuItem>
                        <div className="menu-item" onClick={() => navigate(`/user/${props.user.id}`)}>
                            Edit
                        </div>
                    </MenuItem>
                    <MenuItem>
                        <div className="menu-item" onClick={() => setDialogOpen(true)}>
                            Remove
                        </div>
                    </MenuItem>
                </MenuItems>
            </Menu>
            <ConfirmationDialog
                title="Delete file"
                description="Are you sure you want to delete this user?"
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={() => {
                    props.onRemove(props.user.id);
                    setDialogOpen(false);
                }}
            />
        </div>
    );
}

export default UserRow;
